import QuotaDashboardDatasource from '@/contexts/quota-dashboard/infrastructure/quota-dashboard.datasource'
import QuotaDashboardRepository from '@/contexts/quota-dashboard/infrastructure/quota-dashboard.repository'
import { quotaApiHost, offerApiHost } from '@/contexts/quota-dashboard/config'
import { productSdkWithTimeout } from '@/core/dependency-injection'
import GetQuotaList from '@/contexts/quota-dashboard/use-cases/get-quota-list'

const quotaDashboardDatasource = new QuotaDashboardDatasource({
  productSdk: productSdkWithTimeout,
  quotaApiHost,
  offerApiHost,
})
const quotaDashboardRepository = new QuotaDashboardRepository(quotaDashboardDatasource)
const getQuotaList = new GetQuotaList(quotaDashboardRepository)

export { getQuotaList }
